import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'
import { COLUMN_BYTES } from '../../../lib/columnBytes'

/** İşlem Kodu ad düzenleme form şeması (045): nameTr zorunlu, nameEn opsiyonel; ikisi de ≤ 1000 (DB tanımı). */
export const NAME_MAX_LEN = 1000

export const operationCodeFormSchema = z.object({
  nameTr: requiredText(NAME_MAX_LEN, COLUMN_BYTES.referenceText),
  nameEn: optionalText(NAME_MAX_LEN, COLUMN_BYTES.referenceText),
})

export type OperationCodeFormValues = z.infer<typeof operationCodeFormSchema>
